module.exports = __webpack_public_path__ + "assets/ff331faec62f7ea18316c945424de6f2.jpg";